import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Container } from 'react-bootstrap';
// import Contact from "../../components/C";
export default class HomeContainer extends Component {
  render() {
    return (
      <Container>
        <div></div>
      </Container>
    );
  }
}
